import React from "react";
import ReactMarkdown from "react-markdown";
import type { Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

const COMPONENTS: Components = {
  table: ({ node: _node, ...props }) => (
    <table className="chat__table" {...props} />
  ),
  a: ({ node: _node, children, ...props }) => (
    <a target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ),
};

// Renders the assistant's GFM markdown via react-markdown. rehypeSanitize
// strips raw HTML so untrusted model text can't inject markup; overrides map
// to the existing .chat__md / .chat__table styles.
export default function Markdown({
  text,
  disallowedElements,
}: {
  text: string;
  disallowedElements?: ReadonlyArray<string>;
}) {
  return (
    <div className="chat__md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        disallowedElements={disallowedElements}
        components={COMPONENTS}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
